import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import {BsStarFill} from 'react-icons/bs'
import {ImQuotesLeft} from 'react-icons/im'
import user1 from "../../assets/images/Student-avatar.jpg"
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Review = () => {
    const reviews = [
        {
            name: 'Jhone Dev', 
            id: 11, 
            userImg: user1,
            comment: "The website is easy to navigate and has a clean design. I was able to find what I was looking for quickly.",
            star: [1, 2, 3, 4]
        },
        {
            name: 'Luis Mark',
            id: 21,  
            userImg: user1,
            comment: "I love the wide variety of products available on the website. I always find what I need.",
            star: [1, 2, 3,]
        },
        {
            name: 'Jennifer',
            id: 31,  
            userImg: user1,
            comment: "The website is very slow and often crashes, making it difficult to use. I hope they can improve the performance soon.",
            star: [1, 2, 3, 5]
        },
        {
            name: 'Michael',
            id: 41,  
            userImg: user1,
            comment: "I had a great shopping experience on the website. The checkout process was quick and hassle-free.",
            star: [1, 2, 3,]
        },
        {
            name: 'William',
            id: 51,  
            userImg: user1,
            comment: "The website has a user-friendly interface and the customer service is excellent. I would definitely recommend it to others.",
            star: [1, 2, 3, 5]
        },
    ]
    return (
        <div className='py-5'>
           <div className='text-center font-all my-12'>
                <h1 className='text-2xl sm:text-4xl md:text-5xl font-bold'>স্কুল সম্পর্কে <span className='text-purple-700'>শিক্ষার্থীদের</span> অভিমত</h1>
                <p className='font-bold text-sm sm:text-[18px] mt-2'>শিক্ষার্থীরা সর্বদাই এই স্কুলের প্রতি তাদের ভালবাসা প্রকাশ করেছেন</p>
            </div>
            <Swiper
                loop={true}
                modules={[Pagination]}
                className="mySwiper"
                breakpoints={{
                    300: {
                        slidesPerView: 1,
                    },
                    868: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }}
            >
                {
                    reviews?.map((review, index) => (
                        <div key={index}>
                            <SwiperSlide className=''>
                                <div className='p-4' data-aos="zoom-in-down" data-aos-delay="100" data-aos-duration="800">
                                    <div className="card p-3 bg-base-100 text-start h-full border hover:border-purple-700 hover:shadow-md hover:translate-y-[-5px] transition">
                                        <div className='text-3xl font-bold text-purple-700'><ImQuotesLeft /></div>
                                        <p className='my-2'>{review?.comment.slice(0, 80)}...</p>
                                        <div className="flex items-center justify-between">
                                            <div className="">
                                                <h2 className="text-xl text-purple-700 font-bold my-0">{review?.name}</h2>
                                                <div className="flex ">
                                                    {review?.star.map( (i, index) => <div key={index} className='mx-1 flex font-bold text-xl text-purple-700'> <BsStarFill /> </div>  )}  
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="avatar">
                                                    <div className="w-12 rounded-full ring ring-purple-700 ring-offset-base-100 ring-offset-2">
                                                        <img src={review.userImg} alt='user img' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </div>
                    ))
                }
            </Swiper>
        </div>
    );
};

export default Review;